<template>
  <main>
    <marketing-sms-form :title="title" />
  </main>
</template>

<script>
import MarketingSmsForm from "@components/modules/marketing/sms/generic/form/MarketingSmsForm";

export default {
  components: {
    MarketingSmsForm,
  },

  data() {
    return {
      title: undefined,
    };
  },

  created() {
    this.title = this.$route.query.title;
  },

  computed: {},

  mixins: [],
};
</script>

<style lang="scss" scoped>
</style>
